//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/scroll_view'
import { dxButtonOptions } from 'devextreme/ui/button'
import { dxPopoverOptions } from 'devextreme/ui/popover'

//#endregion

import { IDeferred, IPromise } from 'angular'
import { LocalDictionaryFactory } from '../../api/api.module'
import { ColumnModel } from '../../api/api.models'

import { Activity, Enums } from '../../../models/common'
import { OpDevice, OpTask, OpDataTypeInGroup, OpFile, OpLocationEquipment, OpIssue, OpTaskData, OpTaskStatus } from '../../../models/core'
import { ColumnInfo, OpTaskPaymentElement, OpTaskProtocolVerification } from '../../../models/custom/'
import { OpEmail } from '../../../models/custom/op-email'

import { CommonHelper, ConfigHelper, ConvertHelper, EventsNames, FileComponent, LocalizationHelper, LogHelper, OperatorLayoutSettings, TemplateHelper, ToastHelper, TypeHelper } from '../../../helpers'
import { TaskService } from '../../../services/task'
import { GridService } from '../../../services/grid'
import { SystemService } from '../../../services/system'
import { DeviceService } from '../../../services/device'

import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridBridge } from '../../common/common.interfaces'
import { GridController, GridOptions, GridTypes } from '../../common/grid/'
import { HistorySource } from '../../common/history/'
import { LoggerService } from '../../common/common.module'
import { IPaymentsCreateEdit, PaymentsBridgeOptions, PaymentSubmitResult } from '../../common/payments/'
import { BasicParameter, BasicParametersExtension, IBasicParametersExtension, BasicParameterSize } from '../../common/parameters/extensions'
import { IIMRParameters, IMRParametersOptions, IMRParametersInitializedArgs } from '../../common/parameters'
import { UserSessionService } from '../../../services/user-session'
import { AttachmentService } from '../../../services/attachments'
import { IMRImageInitializedArgs, IMRImageOptions, IIMRImage } from '../../common/image'
import { OpTechnicalPermission } from '../../../models/core/'
import { TechnicalPermissionService } from '../../../services/technical-permission/'
import { TaskTechnicalPermissionsService } from '../../../services/task/'
import { ReferenceTypeService } from '../../../services/reference-type/reference-type.service'
import { DataProviderListResult, DataProviderRequest } from '../../../data-provider'
import { IIMRTaskValidation, IMRTaskValidationInitializedArgs, IMRTaskValidationOptions } from '../task-validate/task-validate.interfaces'
import { IMRTTaskTaskVerificationHistoryOptions } from '../task-verification-history/task-verification-history.interfaces'
import { IIMRPopup, IMRPopupHidingArgs, IMRPopupOptions } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'
import { ISendMail, SendMailInitializedArgs, SendMailOptions } from '../../../modules/common/send-mail/send-mail.interfaces'
import { IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupOptions } from '../../../modules/common/confirmation-popup2'
import { IMRToolbarOptions } from '@imr/controls.angularjs/components/toolbar'

interface TaskDetailsScope extends DetailsScope {
	id: number
}

export class TaskDetailsDirectiveController extends Details<TaskDetailsScope> {
	// #region Consts

	private get ATTACHMENTS_BRIDGE_POPUP_ID(): string {
		return this.$scope.detailsPopupId + 'attachments'
	}
	private get ATTACHMENTS_GRID_NAME(): string {
		return 'attachments'
	}
	private get COLUMNS_CATEGORY_FOR_GRID_EDIT(): string {
		return 'installedEquipment'
	}
	private get INSTALLED_EQUIPMENT_GRID_EDIT_NAME(): string {
		return 'installedEquipmentGrid'
	}
	private get INSTALLED_EQUIPMENT_GRID_NAME(): string {
		return 'installedEquipment'
	}
	private get INSTALLED_EQUIPMENT_POPUP_ID(): string {
		return this.$scope.detailsPopupId + 'installedEquipment'
	}
	private get TASK_EQUIPMENT_GRID_NAME(): string {
		return 'equipment'
	}
	private get TASK_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME(): string {
		return 'TASK_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME'
	}
	private get TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP_ID(): string {
		return this.$scope.detailsPopupId + '_TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP'
	}
	private get TECHNICAL_PERMISSIONS_GRID_NAME(): string {
		return 'TesksModuleTechnicalPermissionsGrid'
	}
	private get UNINSTALLED_EQUIPMENT_GRID_EDIT_NAME(): string {
		return 'uninstalledEquipmentGrid'
	}
	private get UNINSTALLED_EQUIPMENT_GRID_NAME(): string {
		return 'uninstalledEquipment'
	}
	private get UNINSTALLED_EQUIPMENT_POPUP_ID(): string {
		return this.$scope.detailsPopupId + 'uninstalledEquipment'
	}
	private get TASK_ISSUES_GRID_NAME(): string {
		return 'taskIssuesGridName'
	}
	public get GET_ATTACHMENT(): string {
		return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.GetAttachment)
	}
	public get HAS_PERMISSION_CLIENT_PAYMENT_LIST(): boolean {
		return this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_CLIENT_PAYMENT_LIST)
	}
	public get HAS_PERMISSION_TASK_FITTER_PAYMENT_LIST(): boolean {
		return this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_FITTER_PAYMENT_LIST)
	}
	public get NO_ACTIVE_ACCORDIONS(): string {
		return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActiveAccordions)
	}
	public get NO_DEFINED_CONTENT(): string {
		return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDefinedContent)
	}
	public get TASK_ATTACHMENT_NO_PREVIEW(): string {
		return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TaskAttachmentNoPreview)
	}
	public get TASK_ATTACHMENT_PREVIEW_RESIZE(): string {
		return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TaskAttachmentPreviewResize)
	}
	public get TASK_ATTACHMENTS_ACCORDION_NAME(): string {
		return 'TASK_ATTACHMENTS_ACCORDION_NAME'
	}
	public get TASK_COMMON_TAB_NAME(): string {
		return 'common'
	}
	public get TASK_EQUIPMENT_ACCORDION_NAME(): string {
		return 'TASK_EQUIPMENT_ACCORDION_NAME'
	}
	public get TASK_HISTORY_TAB_NAME(): string {
		return 'history'
	}
	public get TASK_VERIFICATION_HISTORY_TAB_NAME(): string {
		return 'TASK_VERIFICATION_HISTORY_TAB_NAME'
	}
	public get TASK_INSTALLED_EQUIPMENT_ACCORDION_NAME(): string {
		return 'TASK_INSTALLED_EQUIPMENT_ACCORDION_NAME'
	}
	public get TASK_PARAMS_ACCORDION_NAME(): string {
		return 'TASK_PARAMS_ACCORDION_NAME'
	}
	public get TASK_PAYMENTS_ACCORDION_NAME(): string {
		return 'TASK_PAYMENTS_ACCORDION_NAME'
	}
	public get TASK_TECHNICAL_PERMISSIONS_ACCORDION_NAME(): string {
		return 'TASK_TECHNICAL_PERMISSIONS_ACCORDION_NAME'
	}
	public get TASK_UNINSTALLED_EQUIPMENT_ACCORDION_NAME(): string {
		return 'TASK_UNINSTALLED_EQUIPMENT_ACCORDION_NAME'
	}

	public get clientHasPayments(): boolean {
		return this.hasPaymentType(Enums.TaskPaymentType.Client)
	}
	public get fitterHasPayments(): boolean {
		return this.hasPaymentType(Enums.TaskPaymentType.Fitter)
	}

	// #endregion

	// #region Members

	public isAttachLoading: boolean
	public attachment: any[]
	public attachmentsBridge: GridBridge
	public attachmentsGridOptions: GridOptions
	public clientPaymentHeader: string
	public clientPaymentParametersOptions: IMRParametersOptions<IBasicParametersExtension>
	public detailsParametersOptions: DetailsParametersOptions
	public downloadButtonOptions: DevExpress.ui.dxButtonOptions
	public equipmentGridOptions: GridOptions
	public fitterPaymentHeader: string
	public fitterPaymentParametersOptions: IMRParametersOptions<IBasicParametersExtension>
	public imageOptions: IMRImageOptions
	public installedEquipmentGridEditOptions: GridBridge
	public installedEquipmentGridOptions: GridOptions
	public paymentsBridgeOptions: PaymentsBridgeOptions
	public taskHistoryOptions: HistorySource
	public uninstalledEquipmentGridEditOptions: GridBridge
	public uninstalledEquipmentGridOptions: GridOptions
	public showAttachmentPreview: boolean
	public deleteConfirmationOptions: {
		title: string
		onConfirmed: () => void
	}
	public showTaskIssues: boolean
	public taskIssuesGridOptions: GridOptions
	public taskValidationOptions: IMRTaskValidationOptions
	public taskVerificationHistoryOptions: IMRTTaskTaskVerificationHistoryOptions

	public mailButtonOptions: dxButtonOptions
	public sendMailPopupOptions: IMRPopupOptions
	public isMailContentLoading: boolean
	public sendMailOptions: SendMailOptions

	public isTaskVerificationHistoryLoading: boolean

	public customActionsButtonOptions: dxButtonOptions
	public customActionsButtonPopoverOptions: dxPopoverOptions
	public acceptTaskButtonOptions: dxButtonOptions
	public declineTaskButtonOptions: dxButtonOptions
	public acceptTaskConfirmationPopupOptions: IMRConfirmationPopupOptions
	public declineTaskConfirmationPopupOptions: IMRConfirmationPopupOptions

	private getTaskRequest: DataProviderRequest<OpTask> = null
	private getTaskAttachmentPackedRequest: DataProviderRequest<OpFile> = null
	private getLocationEquipmentRequest: DataProviderRequest<OpLocationEquipment[]> = null
	private getTaskAttachmentRequest: DataProviderRequest<OpFile[]> = null

	private attachments: OpFile[]
	private attachmentsGrid: GridController<OpFile>
	private clientPaymentParameters: IIMRParameters<IBasicParametersExtension>
	private currency: string
	private downloadButton: DevExpress.ui.dxButton
	private equipmentCount: number
	private equipmentGrid: GridController<OpDevice>
	private fitterPaymentParameters: IIMRParameters<IBasicParametersExtension>
	private id: number
	private imageController: IIMRImage
	private installedEquipmentCount: number
	private installedEquipmentGrid: GridController<OpDevice>
	private paymentsCreateEdit: IPaymentsCreateEdit
	private referenceObject: OpTask
	private referenceObjectId: number
	private uninstalledEquipmentCount: number
	private uninstalledEquipmentGrid: GridController<OpDevice>
	private technicalPermissions: OpTechnicalPermission[]
	private technicalPermissionsGridOptions: GridOptions
	private technicalPermissionsGridEditOptions: GridBridge
	private taskIssues: OpIssue[]
	private taskValidation: IIMRTaskValidation
	private verificationHistoryGrid: GridController<any>
	private isPreviewVisible: boolean

	private sendMailPopup: IIMRPopup
	private sendMail: ISendMail
	private customActionButtonIdentificator: string = 'custom-actions-button'
	private customActionsButtonPopover: DevExpress.ui.dxPopover
	private acceptTaskConfirmationPopup: IIMRConfirmationPopup
	private declineTaskConfirmationPopup: IIMRConfirmationPopup

	private taskProtokols: OpTaskProtocolVerification[]
	private taskProtocolsPromise: JQueryDeferred<void>
	// #endregion

	// #region Ctor

	constructor(
		$scope: TaskDetailsScope,
		$q: ng.IQService,
		$timeout: ng.ITimeoutService,
		logger: LoggerService,
		localDictionary: LocalDictionaryFactory,
		protected userSessionService: UserSessionService,
		private taskService: TaskService,
		private gridService: GridService,
		private systemService: SystemService,
		private deviceService: DeviceService,
		private attachmentService: AttachmentService,
		private technicalPermissionService: TechnicalPermissionService,
		private taskTechnicalPermissionsService: TaskTechnicalPermissionsService,
		private referenceTypeService: ReferenceTypeService,
		protected referenceType: Enums.ReferenceType,
		private moduleName: Enums.SimaxModuleName
	) {
		super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.TaskPopupTabActive, userSessionService, referenceType)

		this.initialize()
	}

	// #endregion

	// #region Events

	private onOpen(options: DetailsOptions): void {
		this.$scope.detailsOpenParams = options

		this.referenceObjectId = options.referenceObjectId

		this.setHistoryOptions()
		this.setTaskValidationOptions()

		this.onClear()
		this.showPopup()
		this.onRefresh()
	}

	private onRefresh(toRefresh: OpTask = null): void {
		this.$scope.options.isDataLoaded = false
		const deferred: JQueryDeferred<OpTask> = $.Deferred<OpTask>()

		if (toRefresh == null) {
			this.getTaskRequest = this.taskService.getTask(this.referenceObjectId)

			this.getTaskRequest
				.then((result: OpTask) => {
					this.$scope.popupTitle = result.toString()
					deferred.resolve(result)
				})
				.always(() => {
					this.$scope.showTabs = true
				})
		} else {
			deferred.resolve(toRefresh)
		}

		deferred.promise()
			.then((result: OpTask) => {
				if (result != null && (this.referenceObject == null || this.referenceObject.idTask == result.idTask)) {
					this.referenceObject = result

					if (this.referenceObject != null) {

						return $.when(
							this.setTaskIssuesGridOptions(),

							this.initializeBasicParameters(),
							this.initializeDownloadButtonOptions(),

							this.initializeParameters(),

							this.initializeInstalledEquipment(),
							this.initializeTechnicalPermissions(result),
							this.initializePayments(),
							this.initializeAttachment(),

							this.prepareTaskVerificationProtocols(result.idTask),

							this.initializeCustomButtonsOptions()
						)
					}
				}
			})
			.always(() => {
				this.$scope.options.isDataLoaded = true
			})
	}

	private initializeAttachment(): void {
		this.setAttachmentParameters()
	}

	private initializePayments(): JQueryPromise<void> {
		return this.taskService
			.getCurrency(this.referenceObject)
			.then((currency: string) => {
				this.currency = currency
			})
			.catch(() => {
				this.currency = null
			})
			.always(() => {
				this.initializePaymentsAccordion()
				this.initializePaymentsBridgeOptions()
				this.initializeClientPaymentParameters()
				this.initializeFitterPaymentParameters()
			})
	}

	private onClear(): void {
		if (this.getTaskRequest != null) {
			this.getTaskRequest.cancel()
		}

		if (this.getTaskAttachmentPackedRequest != null) {
			this.getTaskAttachmentPackedRequest.cancel()
		}

		if (this.getLocationEquipmentRequest != null) {
			this.getLocationEquipmentRequest.cancel()
		}

		if (this.getTaskAttachmentRequest != null) {
			this.getTaskAttachmentRequest.cancel()
		}

		this.$scope.popupTitle = TypeHelper.emptyString
		this.$scope.showTabs = false

		this.referenceObject = null

		this.detailsParametersOptions = null

		this.installedEquipmentGridOptions = null
		this.installedEquipmentCount = 0
		this.installedEquipmentGridEditOptions = null

		this.uninstalledEquipmentGridOptions = null
		this.uninstalledEquipmentCount = 0
		this.uninstalledEquipmentGridEditOptions = null

		this.equipmentGridOptions = null

		this.attachmentsGridOptions = null
		this.attachmentsBridge = null

		this.paymentsBridgeOptions = null

		this.taskVerificationHistoryOptions = null
		this.taskProtokols = null
		this.taskProtocolsPromise = $.Deferred<void>()
	}

	private onClose(): void {
		this.hidePopup()
	}

	private onConfirmDelete(): void {
		this.taskService.deleteTask(this.referenceObject).then(() => {
			this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
			this.onClose()
		})
	}

	private onDelete(): void {
		this.$scope.$broadcast(
			EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.detailsPopupId,
			LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
		)
	}

	private onEditTaskParams(): void {
		const createEditInitParams: CreateEditInitParams = this.taskService.getCreateEditOptions(this.referenceObject.idTask, this.referenceObject)
		this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
	}

	// #endregion

	// #region Setup

	private initialize() {
		this.setConfirmationsOptions()
		this.setEvents()
		this.setOptions()
		this.setImageOptions()

		if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_LIST)) {
			this.configureTabs(this.getTabs())
		}
	}

	private setImageOptions() {
		this.imageOptions = {
			onInitialized: (e: IMRImageInitializedArgs) => {
				this.imageController = e.component
			},
		}
	}

	private initializeBasicParameters(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		this.taskService.getBasicParametersDataTypeGroup().then((dataTypeInGroup: OpDataTypeInGroup[]) => {
			this.detailsParametersOptions = {
				dataTypes: dataTypeInGroup,
				referenceType: this.referenceType,
				referenceObject: this.referenceObject,
				useDynamicValues: true,
				onDataLoaded: () => {
					def.resolve()
				}
			}
		})
			.catch(() => {
				def.reject()
			})

		if (this.isAccordionHidden(this.$scope.TASK_PARAMS_ACCORDION_NAME)) {
			def.resolve()
		}

		return def.promise()
	}

	// #region Accordions

	public getAccordions(): DetailsAccordion[] {
		const accordions: DetailsAccordion[] = []
		let items: DetailsAccordionSection[] = []

		if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskParameters)) {
			items.push({
				name: this.TASK_PARAMS_ACCORDION_NAME,
				showInTab: this.TASK_COMMON_TAB_NAME,
				showStatus: true,
				title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
				visible: true,
				canEdit:
					this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_EDIT) &&
					!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskParameters),
				editMethod: () => this.onEditTaskParams(),
			})

			accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.taskDetailsAccordions, 0, items))
		}

		if (
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskInstalledEquipment) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskUninstalledEquipment)
		) {
			items = []

			if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskInstalledEquipment)) {
				items.push({
					name: this.TASK_INSTALLED_EQUIPMENT_ACCORDION_NAME,
					showInTab: this.TASK_COMMON_TAB_NAME,
					showStatus: true,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledEquipment),
					visible: true,
					canEdit:
						this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_EDIT) &&
						!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskInstalledEquipment),
					editMethod: () => this.onEditInstalledEquipment(),
					status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Amount) + ': ' + this.installedEquipmentCount,
				})
			}

			if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskUninstalledEquipment)) {
				items.push({
					name: this.TASK_UNINSTALLED_EQUIPMENT_ACCORDION_NAME,
					showInTab: this.TASK_COMMON_TAB_NAME,
					showStatus: true,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UninstalledEquipment),
					visible: true,
					canEdit:
						this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_EDIT) &&
						!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskUninstalledEquipment),
					editMethod: () => this.onEditUninstalledEquipment(),
					status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Amount) + ': ' + this.uninstalledEquipmentCount,
				})
			}

			accordions.push(
				new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.taskDetailsAccordions, 1, items, true, (component: DevExpress.ui.dxAccordion) => {
					this.$timeout(() => {
						component.expandItem(1)
						component.expandItem(2)
					})
				})
			)
		}

		if (
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskSummaryPayments) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskAttachments) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskEquipment) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskTechnicalPermissions, true) ||
			!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskIssues, true)
		) {
			items = []

			if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskSummaryPayments)) {
				items.push({
					name: this.TASK_PAYMENTS_ACCORDION_NAME,
					showInTab: this.TASK_COMMON_TAB_NAME,
					showStatus: true,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Payments),
					visible: true,
					canEdit:
						this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_EDIT) &&
						!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskSummaryPayments),
					editMethod: () => this.onEditPayments(),
				})
			}

			if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskAttachments)) {
				items.push({
					name: this.TASK_ATTACHMENTS_ACCORDION_NAME,
					showInTab: this.TASK_COMMON_TAB_NAME,
					showStatus: true,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Attachments),
					visible: true,

					canEdit:
						this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_EDIT) &&
						!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskAttachments),

					editMethod: () => this.onEditTaskAttachments(),
					status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AddedCount) + _.size(this.attachments),
				})
			}

			if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskEquipment)) {
				items.push({
					name: this.TASK_EQUIPMENT_ACCORDION_NAME,
					showInTab: this.TASK_COMMON_TAB_NAME,
					showStatus: true,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Equipment),
					visible: true,
					canEdit: false,
					status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledCount) + this.equipmentCount,
				})
			}

			if (!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskTechnicalPermissions, true)) {
				items.push({
					title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__TECHNICAL_PERMISSIONS, Enums.SimaxModuleName.Task),
					name: this.TASK_TECHNICAL_PERMISSIONS_ACCORDION_NAME,
					showStatus: true,
					visible: true,

					canEdit:
						this.userSession.getLoggedOperator().hasPermission(Activity.TASK_EDIT) &&
						!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskTechnicalPermissions, true),

					editMethod: () => {
						this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.$scope.detailsPopupId + '_TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP')
					},

					status: () => {
						return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount) + _.size(this.technicalPermissions)
					},
				})
			}

			if (!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskIssues, true)) {
				items.push({
					canEdit: false,

					name: this.$scope.TASK_ISSUES_TABLE_ACCORDION_NAME,
					showInTab: this.$scope.TASK_COMMON_TAB_NAME,
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Issues),

					showStatus: true,
					visible: true,

					status: () => `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssuesCount)} ${_.size(this.taskIssues)}`,
				})
			}

			accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.taskDetailsAccordions, 2, items))
		}

		return accordions
	}

	// #endregion

	// #region Tabs

	public getTabs(): any[] {
		const tabs: any[] = []

		if (
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskParameters) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskAttachments) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskInstalledEquipment) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskUninstalledEquipment) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskEquipment) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskSummaryPayments) ||
			!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskTechnicalPermissions, true)
		) {
			tabs.push({
				template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSessionService),
				name: this.TASK_COMMON_TAB_NAME,
			})
		}

		if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskHistory)) {
			tabs.push({
				template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History), ConfigHelper.Icon.HISTORY, this.userSessionService),
				name: this.TASK_HISTORY_TAB_NAME,
			})
		}

		if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_PROTOCOL_VERIFICATION_VIEW)) {
			tabs.push({
				template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Verification), ConfigHelper.Icon.ACTIONS, this.userSessionService),
				name: this.TASK_VERIFICATION_HISTORY_TAB_NAME,
			})
		}

		return tabs
	}

	private setHistoryOptions(): void {
		this.taskHistoryOptions = {
			dataMethodName: null, // DO USUNIĘCIA
			id: null, // DO USUNIĘCIA
			name: this.TASK_HISTORY_TAB_NAME,
			referenceType: this.referenceType,
			referenceValue: this.referenceObjectId,
			allowColumnReordering: !this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskHistory),
			// onRowDoubleClick: (opHistory: OpHistory) => {
			//     this.onHistoryRowDoubleClick(opHistory)
			// }
		}
	}

	private prepareTaskVerificationProtocols(idTask: number): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_PROTOCOL_VERIFICATION_VIEW)) {
			this.isTaskVerificationHistoryLoading = true
			this.getTaskProtocolToVerification(idTask)
				.then((protocols: OpTaskProtocolVerification[]) => {
					this.taskProtokols = protocols
					this.initializeTaskVerificationHistoryOptions(protocols)
				})
				.catch(() => {
					this.initializeTaskVerificationHistoryOptions([])
					this.taskProtocolsPromise.reject()
				})
				.always(() => {
					this.isTaskVerificationHistoryLoading = false
					this.taskProtocolsPromise.resolve()
					def.resolve()
				})
		} else {
			this.taskProtocolsPromise.resolve()
			def.resolve()
		}

		return def.promise()
	}

	private initializeTaskVerificationHistoryOptions(protokols: OpTaskProtocolVerification[]): void {
		this.taskVerificationHistoryOptions = {
			referenceValue: this.referenceObjectId,
			dataSource: protokols,
			onInitialized: (grid: GridController<any>) => {
				this.verificationHistoryGrid = grid
			},
			onRowDoubleClick: (opTaskProtocolVerification: OpTaskProtocolVerification) => {
				this.onHistoryRowDoubleClick(opTaskProtocolVerification)
			},
		}
	}

	private setTaskValidationOptions(): void {
		this.taskValidationOptions = {
			onInitialized: (e: IMRTaskValidationInitializedArgs) => {
				this.taskValidation = e.component
			},
			onSubmited: (status: Enums.TaskProtocolVerificationStatus, index: number, reason: string): JQueryPromise<void> => {
				return this.onTaskVerificationSubmit(status, index, reason)
			},
		}
	}

	private onTaskVerificationSubmit(status: Enums.TaskProtocolVerificationStatus, index: number, reason: string): JQueryPromise<void> {
		const deferred: JQueryDeferred<void> = $.Deferred<void>()
		const taskToSave: OpTask = new OpTask()
		taskToSave.idTask = this.referenceObjectId
		taskToSave.opState = Enums.OpChangeState.Loaded

		const statusData: OpTaskData = new OpTaskData(null)
		statusData.idDataType = Enums.DataType.TASK_PROTOCOL_VERIFICATION_STATUS
		statusData.idTask = this.referenceObjectId
		statusData.indexNbr = index
		statusData.value = status
		statusData.opState = Enums.OpChangeState.New

		taskToSave.dataList.push(statusData)

		if (reason != null) {
			const reasonData: OpTaskData = new OpTaskData(null)
			reasonData.idDataType = Enums.DataType.TASK_PROTOCOL_VERIFICATION_REJECTION_NOTE
			reasonData.idTask = this.referenceObjectId
			reasonData.indexNbr = index
			reasonData.value = reason
			reasonData.opState = Enums.OpChangeState.New

			taskToSave.dataList.push(reasonData)
		}

		this.taskService
			.saveTask(taskToSave)
			.then((savedTask: OpTask) => {
				this.prepareTaskVerificationProtocols(savedTask.idTask)
				//this.onRefresh(savedTask)
				deferred.resolve()
			})
			.catch(() => {
				deferred.reject()
			})

		return deferred.promise()
	}

	private getTaskProtocolToVerification(idTask: number): JQueryPromise<OpTaskProtocolVerification[]> {
		return this.userSessionService
			.getDataProvider()
			.Task.getTaskProtocolToVerification(idTask)
			.then((protocols: OpTaskProtocolVerification[]) => {
				return protocols
			})
	}

	private onHistoryRowDoubleClick(opTaskProtocolVerification: OpTaskProtocolVerification): void {
		if (
			this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_PROTOCOL_VERIFICATION_VIEW) &&
			this.referenceObject.idTaskStatus != Enums.TaskStatus.Not_Started &&
			this.referenceObject.idTaskStatus != Enums.TaskStatus.Planned
		) {
			if (this.taskValidation != null) {
				this.taskValidation.show(opTaskProtocolVerification)
			}
		}
	}

	// #endregion

	// #region Confirmation

	private setConfirmationsOptions(): void {
		this.deleteConfirmationOptions = {
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),
			onConfirmed: () => this.onConfirmDelete(),
		}
	}

	// #endregion

	private setEvents(): void {
		this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id, (event: ng.IAngularEvent, ...args: any[]) =>
			this.onOpen(args[3])
		)

		this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id, () => this.onClose())

		this.$scope.$on(EventsNames.DOWNLOAD_TASK_ATTACHMENT + this.$scope.detailsPopupId, (event: ng.IAngularEvent, ...args: any[]) => {
			FileComponent.OpenFileSaver(this.attachmentsGrid.selectedItem)
		})

		this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0]))

		this.$scope.$on(EventsNames.CLOSE_GRID_ATTACHMENTS_EDIT_POPUP + this.ATTACHMENTS_BRIDGE_POPUP_ID, (event: ng.IAngularEvent, ...args: any[]) => {
			this.attachmentsGrid.table.refresh()
		})
	}

	private setOptions(): void {
		this.$scope.options = <DetailsPopupOptions>{
			id: this.$scope.id,
			closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),
			delHasPermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DEL) ? Activity[Activity.TASK_DEL] : null,
			openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),
			deleteMethod: () => this.onDelete(),
			getAccordionDataMethod: () => this.getAccordionData(),
			getAccordionSelectionMethod: () => this.getAccordionSelection(),
			updateAccordionMethod: (names: any[]) => this.updateAccordions(names),
		}
	}

	// #endregion

	// #region Download Attachment Button

	private initializeDownloadButtonOptions(): void {
		this.downloadButtonOptions = {
			onClick: (e: any) => {
				e.event.stopPropagation()
				this.savePackedAttachment()
			},
			onInitialized: (e: any) => {
				this.downloadButton = e.component
			},
			template: TemplateHelper.getIcon(ConfigHelper.Icon.EXPORT, this.userSessionService),
			hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.GetPackedAttachment),
		}
	}

	private savePackedAttachment(): void {
		this.getTaskAttachmentPackedRequest = this.userSessionService.getDataProvider().Task.getTaskAttachmentPacked(this.referenceObjectId, null)

		this.getTaskAttachmentPackedRequest
			.then((result: OpFile) => {
				FileComponent.OpenFileSaver(result)
			})
			.fail((error: any) => {
				ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AttachmentDownloadError))
			})
	}

	// #endregion

	// #region Installed Equipment

	private initializeEquipmentGridEdit(columns): void {
		this.setInstalledEquipmentGridEditOptions(this.referenceObject.installedDevices != null ? this.referenceObject.installedDevices : [], columns)
	}

	private initializeInstalledEquipment(): JQueryPromise<void> {
		return this.taskService.getInstalledEquipmentParameters().then((columns: ColumnModel[]) => {
			if (this.referenceObject != null) {
				this.setInstalledEquipmentGridOptions(this.referenceObject.installedDevices, columns)

				this.initializeEquipmentGridEdit(columns)

				this.installedEquipmentCount = _.size(this.referenceObject.installedDevices)
			}
		})
	}

	private setInstalledEquipmentGridOptions(devices: OpDevice[], columns: ColumnModel[]): void {
		this.installedEquipmentGridOptions = null

		this.$timeout(() => {
			this.installedEquipmentGridOptions = {
				name: this.INSTALLED_EQUIPMENT_GRID_NAME,
				type: GridTypes.PAGINATED_SMALL,
				buttonsOptions: {
					enabled: false,
				},
				addCustomFilters: false,
				scrolling: true,
				columnsDictionary: columns,
				allowColumnReordering: this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskInstalledEquipment),
				dataSource: devices,
				onInitialized: (e: any, grid: GridController<OpDevice>) => {
					this.installedEquipmentGrid = grid
				},
				onRowDoubleClick: (e: any) => this.showDeviceDetails(e),
			}
		}, 100)
	}

	private showDeviceDetails(e: any): void {
		if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)) {
			this.systemService.openDetails(this.deviceService.getDetailsOptions(e.data[CommonHelper.idField]))
		}
	}

	private setInstalledEquipmentGridEditOptions(devices: OpDevice[], columns: ColumnModel[]): void {
		this.installedEquipmentGridEditOptions = null

		this.installedEquipmentGridEditOptions = {
			columns,
			id: this.referenceObjectId,
			items: devices.map((device: OpDevice) => {
				const item: any = this.gridService.gridObjectFromIOpObject(device)

				if (item != null) {
					for (let field in item) {
						if (field != null) {
							if (ConvertHelper.isNetDateFormat(item[field])) {
								item[field] = ConvertHelper.stringToDate(item[field])
							}
						}
					}
				}

				return item
			}),
			name: this.INSTALLED_EQUIPMENT_GRID_EDIT_NAME,
			popupId: this.INSTALLED_EQUIPMENT_POPUP_ID,
			title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledEquipment),

			allowColumnReordering: !this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskInstalledEquipment),
			allowDublicatedRow: false,
			// data: fitterDevices,
			onSubmit: (added: any[], removed: any[], inGrid: any[]) => {
				return this.onInstalledEquipmentSubmit(added, removed, inGrid)
			},
			getAvailableDataSourceMethod: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => this.getAvailableDevices(columns, pageNbr, pageSize, customWhereClause),
		}
	}

	private getAvailableDevices(columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<DataProviderListResult<OpDevice>> {
		return this.userSession
			.getDataProvider()
			.Operator.getOperatorDepositoryContentFilter(this.userSessionService.getLoggedOperator().idOperator, columns, pageNbr, pageSize, customWhereClause)
			.then((result: DataProviderListResult<OpLocationEquipment>) => {
				const devicesList: DataProviderListResult<OpDevice> = {
					objects: result.objects.map((locEquipment: OpLocationEquipment) => {
						return locEquipment.device
					}),
					totalCount: result.totalCount,
					error: result.error,
				}

				return devicesList
			})
	}

	private onInstalledEquipmentSubmit(added: any[], removed: any[], inGrid: any[]): ng.IPromise<boolean> {
		const deferred: ng.IDeferred<boolean> = this.$q.defer<boolean>()
		this.taskService.onInstalledEquipmentSubmit(added, removed, inGrid, this.referenceObject).then((locationEquipments: OpLocationEquipment[]) => {
			this.saveChangeLocationEquipment(this.referenceObjectId, locationEquipments)
				.then(() => {
					deferred.resolve(true)
				})
				.fail(() => {
					deferred.resolve(false)
				})
		})

		return deferred.promise
	}

	private onEditInstalledEquipment(): void {
		this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.INSTALLED_EQUIPMENT_POPUP_ID, this.COLUMNS_CATEGORY_FOR_GRID_EDIT, false)
	}

	// #endregion

	// #region UnistalledEquipment

	private initializeUninstalledEquipmentParameters(locationEquipment: OpLocationEquipment[]): JQueryPromise<void> {
		return this.gridService
			.getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__UNINSTALLED_DEVICES_GRID_PARAMS, Enums.SimaxModuleName.Task, {
				viewReferenceType: Enums.ReferenceType.SerialNbr,
			})
			.then((columns: ColumnModel[]) => {
				if (this.referenceObject != null) {
					this.setUninstalledEquipmentGridOptions(this.referenceObject.uninstalledDevices, columns)

					const devices: OpDevice[] = this.getLocationDevices(locationEquipment)

					if (this.referenceObject.uninstalledDevices != null) {
						this.setUninstalledEquipmentGridEditOptions(this.referenceObject.uninstalledDevices, devices, columns)
					} else {
						this.setUninstalledEquipmentGridEditOptions([], devices, columns)
					}

					this.uninstalledEquipmentCount = _.size(this.referenceObject.uninstalledDevices)
				}
			})
	}

	private setUninstalledEquipmentGridOptions(devices: OpDevice[], columns: ColumnModel[]): void {
		this.uninstalledEquipmentGridOptions = null
		this.$timeout(() => {
			this.uninstalledEquipmentGridOptions = {
				name: this.UNINSTALLED_EQUIPMENT_GRID_NAME,
				type: GridTypes.PAGINATED_SMALL,
				buttonsOptions: {
					enabled: false,
				},
				addCustomFilters: false,
				scrolling: true,
				columnsDictionary: columns,
				allowColumnReordering: this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskUninstalledEquipment),
				dataSource: devices,
				onInitialized: (e: any, grid: GridController<OpDevice>) => {
					this.uninstalledEquipmentGrid = grid
				},
				onRowDoubleClick: (e: any) => this.showDeviceDetails(e),
			}
		}, 100)
	}

	private setUninstalledEquipmentGridEditOptions(devices: OpDevice[], locationDevices: OpDevice[], columns: ColumnModel[]): void {
		this.uninstalledEquipmentGridEditOptions = null
		this.uninstalledEquipmentGridEditOptions = {
			columns,
			id: this.referenceObjectId,
			items: devices.map((device: OpDevice) => this.gridService.gridObjectFromIOpObject(device)),
			name: this.UNINSTALLED_EQUIPMENT_GRID_EDIT_NAME,
			popupId: this.UNINSTALLED_EQUIPMENT_POPUP_ID,
			title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UninstalledEquipment),

			allowColumnReordering: !this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskUninstalledEquipment),

			data: locationDevices,
			onSubmit: (added: any[], removed: any[], inGrid: any[]) => {
				return this.onUninstalledEquipmentSubmit(added, removed, inGrid)
			},
		}
	}

	private onUninstalledEquipmentSubmit(added: any[], removed: any[], inGrid: any[]): ng.IPromise<boolean> {
		const deferred: ng.IDeferred<boolean> = this.$q.defer<boolean>()
		this.taskService.onUninstalledEquipmentSubmit(added, removed, inGrid, this.referenceObject).then((locationEquipments: OpLocationEquipment[]) => {
			this.saveChangeLocationEquipment(this.referenceObjectId, locationEquipments)
				.then(() => {
					deferred.resolve(true)
				})
				.fail(() => {
					deferred.resolve(false)
				})
		})
		return deferred.promise
	}

	private getLocationDevices(locationEquipment: OpLocationEquipment[]): OpDevice[] {
		return locationEquipment.map((equipmentData: OpLocationEquipment) => equipmentData.device)
	}

	private onEditUninstalledEquipment(): void {
		this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.UNINSTALLED_EQUIPMENT_POPUP_ID, this.COLUMNS_CATEGORY_FOR_GRID_EDIT, false)
	}

	// #endregion

	// #region Equipment

	private getEquipment(): JQueryPromise<OpLocationEquipment[]> {
		this.getLocationEquipmentRequest = this.userSessionService.getDataProvider().Location.getLocationEquipment(this.referenceObject.idLocation)

		return this.getLocationEquipmentRequest.then((locationEquipment: OpLocationEquipment[]) => {
			if (_.size(locationEquipment) > 0) {
				return locationEquipment
			} else {
				return []
			}
		})
	}

	private initializeParameters(): JQueryPromise<void> {
		const def: JQueryDeferred<void> = $.Deferred<void>()

		if (
			this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_LIST) &&
			(!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskEquipment) ||
				!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskUninstalledEquipment))
		) {
			this.getEquipment().then((locationEquipment: OpLocationEquipment[]) => {
				this.equipmentCount = _.size(locationEquipment)

				$.when(
					this.initializeEquipmentParameters(locationEquipment),
					this.initializeUninstalledEquipmentParameters(locationEquipment)
				).always(() => {
					def.resolve()
				})
			})
		} else {
			def.resolve()
		}

		return def.promise()
	}

	private initializeEquipmentParameters(equipment: OpLocationEquipment[]): void {
		this.setEquipmentGridOptions(equipment)
	}

	private equipmentDataSourceParser(): any {
		return (equipment: OpLocationEquipment) => {
			if (equipment == null) {
				return null
			}

			const additionalFieldsObj: { additionalFields: { key: string; value: any }[] } = {
				additionalFields: [],
			}

			//columns are hardcoded in taskService.getEquipmentColumns() so keys bellow too
			//#region deice
			if (equipment.device != null) {
				additionalFieldsObj.additionalFields.push({
					key: 'device',
					value: equipment.device.toString(),
				})
			}
			//#endregion

			//#region meter
			if (equipment.meter != null) {
				additionalFieldsObj.additionalFields.push({
					key: 'meter',
					value: equipment.meter.toString(),
				})
			}
			//#endregion

			//#region time
			additionalFieldsObj.additionalFields.push({
				key: 'startTime',
				value: equipment.startTime,
			})
			//#endregion

			return additionalFieldsObj
		}
	}

	private setEquipmentGridOptions(equipment: OpLocationEquipment[]): void {
		this.equipmentGridOptions = null

		this.$timeout(() => {
			this.equipmentGridOptions = {
				name: this.TASK_EQUIPMENT_GRID_NAME,
				type: GridTypes.PAGINATED_SMALL,
				buttonsOptions: {
					enabled: false,
				},
				addCustomFilters: false,
				scrolling: true,
				columnsDictionary: this.taskService.getEquipmentColumns(),
				allowColumnReordering: this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskEquipment),
				dataSource: equipment,
				dataSourceParser: this.equipmentDataSourceParser(),
				onInitialized: (e: any, grid: GridController<OpDevice>) => {
					this.equipmentGrid = grid
				},
				onRowDoubleClick: (e: any) => this.showDeviceDetails(e),
			}
		}, 100)
	}

	// #endregion

	// #region Payments

	private initializePaymentsAccordion(): void {
		const task: OpTask = this.referenceObject

		const paymentAmount: number = task.paymentAmount != null ? task.paymentAmount : 0
		const clientPaymentAmount: number = task.clientPaymentAmount != null ? task.clientPaymentAmount : 0

		this.clientPaymentHeader = this.getPaymentHeader(
			LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Client),
			task.clientPaymentDone,
			task.clientOrderedToPay,
			clientPaymentAmount,
			task.clientPaymentDate
		)

		this.fitterPaymentHeader = this.getPaymentHeader(
			LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Fitter),
			task.fitterPaymentDone,
			task.fitterOrderedToPay,
			paymentAmount,
			task.fitterPaymentDate
		)
	}

	private getPaymentHeader(operatorType: string, isPaymentDone: boolean, isOrderedToPay: boolean, due: number, paymentDate: Date): string {
		let tempString: string = operatorType + ' (' + due + ' ' + (this.currency || TypeHelper.emptyString)

		if (isPaymentDone) {
			tempString +=
				'/' + LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentDone) + ' ' + moment(paymentDate).format(ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_FORMAT_MOMENTJS))
		} else if (isOrderedToPay) {
			tempString += '/' + LocalizationHelper.getLocalizedText(LocalizationHelper.Text.OrderedToPay)
		}
		tempString += ')'

		return tempString
	}

	private hasPaymentType(paymentType: Enums.TaskPaymentType): boolean {
		return _.some(this.referenceObject.payments, (payment: OpTaskPaymentElement) => payment.paymentType === paymentType)
	}

	private initializePaymentsBridgeOptions(): JQueryPromise<any> {
		this.paymentsBridgeOptions = null

		this.paymentsBridgeOptions = {
			onInitialized: (paymentsCreateEditOptions: IPaymentsCreateEdit) => {
				this.paymentsCreateEdit = paymentsCreateEditOptions
			},
			source: this.referenceObject,
			currency: this.currency,
			isClientPaymentsEdited: false,
			isFitterPaymentsEdited: false,
			popupId: this.referenceObjectId,
			popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Payments),
			editAllowed: this.referenceObject.idTaskStatus == Enums.TaskStatus.WaitingForAcceptance,
			onSubmit: (paymentObj: PaymentSubmitResult) => {
				return this.onPaymentSubmit(paymentObj)
			},
		}

		return TypeHelper.onInitializedAll(this.paymentsBridgeOptions)
	}

	private onPaymentSubmit(paymentObj: PaymentSubmitResult): JQueryPromise<void> {
		const defer: JQueryDeferred<void> = $.Deferred<void>()

		if (this.referenceObject != null) {
			paymentObj.formData.creationDate = this.referenceObject.creationDate
		}

		this.taskService.saveTaskPayments(paymentObj).then((task: OpTask) => {
			this.onRefresh(task)
			defer.resolve()
		})
		return defer.promise()
	}

	private onEditPayments(): void {
		this.paymentsCreateEdit.open()
	}

	private initializeClientPaymentParameters(): void {
		let parameters: BasicParameter[] = []
		if (this.referenceObject != null) {
			if (_.size(this.referenceObject.payments) > 0) {
				parameters = this.getPaymentParameters(Enums.TaskPaymentType.Client)
			}
			if (this.clientPaymentParameters != null) {
				this.clientPaymentParameters.extension.setParameters(parameters)
				this.clientPaymentParameters.refresh()
			} else {
				this.clientPaymentParametersOptions = {
					extension: new BasicParametersExtension({
						parameters: parameters,
					}),

					showEmpty: true,

					onInitialized: (e: IMRParametersInitializedArgs<IBasicParametersExtension>) => {
						this.clientPaymentParameters = e.component
					},
				}
			}
		}
	}

	private initializeFitterPaymentParameters(): void {
		let parameters: BasicParameter[] = []
		if (this.referenceObject != null) {
			if (_.size(this.referenceObject.payments) > 0) {
				parameters = this.getPaymentParameters(Enums.TaskPaymentType.Fitter)
			}

			if (this.fitterPaymentParameters != null) {
				this.fitterPaymentParameters.extension.setParameters(parameters)
				this.fitterPaymentParameters.refresh()
			} else {
				this.fitterPaymentParametersOptions = {
					extension: new BasicParametersExtension({
						parameters: parameters,
					}),

					showEmpty: true,

					onInitialized: (e: IMRParametersInitializedArgs<IBasicParametersExtension>) => {
						this.fitterPaymentParameters = e.component
					},
				}
			}
		}
	}

	private getPaymentParameters(paymentType: Enums.TaskPaymentType): BasicParameter[] {
		return this.referenceObject.payments
			.filter((payment: OpTaskPaymentElement) => payment.paymentType === paymentType)
			.map((payment: OpTaskPaymentElement) => {
				const basicParam: BasicParameter = {
					caption: payment.description,
					value: payment.value,
					unit: this.currency,
					size: BasicParameterSize.Normal,
				}
				return basicParam
			})
	}

	// #endregion

	// #region Attachment

	private setAttachmentParameters(files: OpFile[] = null): IPromise<void> {
		const deferred: IDeferred<void> = this.$q.defer<void>()
		this.isAttachLoading = true

		if (_.size(files) === 0) {
			this.getTaskAttachmentRequest = this.userSessionService.getDataProvider().Task.getTaskAttachment(this.referenceObjectId)

			this.getTaskAttachmentRequest
				.then((result: OpFile[]) => {
					this.setAttachemntsGridsOptions(result)

					deferred.resolve()
				})
				.fail((error: any) => {
					ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error))

					deferred.reject()
				})
				.always(() => {
					this.isAttachLoading = false
				})
		} else {
			this.setAttachemntsGridsOptions(files)

			this.isAttachLoading = false

			deferred.resolve()
		}

		return deferred.promise
	}

	private setAttachemntsGridsOptions(files: OpFile[]): void {
		this.attachments = files
		this.setAttachmentsEditOptions(files)
		this.setAttachmentGridOptions(files)
		this.setAttachmentBridgeOptions(files)
	}

	private setAttachmentGridOptions(attachments: OpFile[]): void {
		this.attachmentsGridOptions = null

		const attachmentsColumns: ColumnModel[] = this.attachmentService.getAttachmentGridColumns()
		attachmentsColumns.push(CommonHelper.getAttachmentButtonColumn(this.$scope, EventsNames.DOWNLOAD_TASK_ATTACHMENT + this.$scope.detailsPopupId))

		this.$timeout(() => {
			this.attachmentsGridOptions = {
				name: this.ATTACHMENTS_GRID_NAME,
				idReferenceType: Enums.ReferenceType.IdFile,
				type: GridTypes.NO_SEARCH_BAR_SMALL,
				buttonsOptions: {
					enabled: false,
				},
				addCustomFilters: true,
				dataSource: attachments,
				columnsDictionary: attachmentsColumns,
				allowColumnReordering: !this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskAttachments),
				onRowDoubleClick: () => {
					this.onAttachmentRowDoubleClick()
				},
				onInitialized: (e: any, attachmentsGrid: GridController<OpFile>) => {
					this.attachmentsGrid = attachmentsGrid
				},
				onContentReady: (e: any) => this.onAttachmentContentReady(),
				onSelectionChanged: (e: any) => this.showPreview(),
			}
			if (this.downloadButton) {
				this.downloadButton.option('visible', !!attachments.length)
			}
		}, 100)
	}

	private setAttachmentsEditOptions(result: OpFile[]): void {
		this.showAttachmentPreview = false
		this.attachment = result
	}

	private setAttachmentBridgeOptions(result: OpFile[]): void {
		if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskAttachments)) {
			this.attachmentsBridge = null

			this.attachmentsBridge = {
				id: null,
				title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AttachmentsEdit) + ' (' + this.attachments.length + ')',
				items: result,
				popupId: this.ATTACHMENTS_BRIDGE_POPUP_ID,
				columns: this.attachmentService.getAttachmentGridColumns(),
				data: [],
				allowColumnReordering: !this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskAttachments),
				deleteAttachmentPermission: this.userSession.getLoggedOperator().hasPermission(Activity.TASK_ATTACHMENT_DELETE),
				onDelete: (removed: number[]) => this.onDeleteAttachment(removed),
				onFileAdded: (added: OpFile) => this.onSaveAttachment(added),
			}
		}
	}

	private onSaveAttachment(added: OpFile): ng.IPromise<OpFile> {
		const deferred = this.$q.defer<any>()

		this.taskService
			.saveTaskAttachment(this.$scope.modelId, added)
			.then((data: OpFile) => {
				if (data != null) {
					this.setAttachmentParameters(this.attachments.concat([data]))
						.then(() => {
							deferred.resolve()
						})
						.catch(() => {
							deferred.reject()
						})
				}

				deferred.reject()
			})
			.fail(() => {
				deferred.reject()
			})

		return deferred.promise
	}

	private onDeleteAttachment(removed: number[]): ng.IPromise<any[]> {
		const deferred = this.$q.defer<any[]>()

		this.taskService
			.deleteTaskAttachment(this.$scope.modelId, removed)
			.then(() => {
				this.attachments = this.attachments.filter((file: OpFile) => {
					return removed.indexOf(file.idFile) === -1
				})
				this.setAttachmentParameters(this.attachments)
					.then(() => {
						deferred.resolve()
					})
					.catch(() => {
						deferred.reject()
					})
			})
			.fail(() => {
				deferred.reject()
			})

		return deferred.promise
	}

	private onAttachmentContentReady(): void {
		this.showPreview()
	}

	private onAttachmentRowDoubleClick(): void {
		if (this.getProfileData(Enums.DataType.TASK_ATTACHMENT_OPEN_IN_NEW_WINDOW)) {
			if (this.attachmentsGrid.selectedItem == null || this.attachmentsGrid.selectedItem.fileBytes == null) {
				throw Error('OpenFileSaver - no file to save')
			}

			const fileName: string = this.attachmentsGrid.selectedItem.physicalFileName
			const mime = require('mime-types')
			const type: string = mime.lookup(fileName)
			const blob: Blob = new Blob([new Uint8Array(<number[]>this.attachmentsGrid.selectedItem.fileBytes)], { type: type })
			window.open(URL.createObjectURL(blob))
		} else {
			FileComponent.OpenFileSaver(this.attachmentsGrid.selectedItem)
		}
	}

	private showPreview(): void {
		this.isPreviewVisible = false
		if (this.attachmentsGrid != null && this.attachmentsGrid.selectedItem != null) {
			this.imageController.setImage(this.attachmentsGrid.selectedItem)
			this.isPreviewVisible = true
		}
	}

	private onEditTaskAttachments(): void {
		this.$scope.$broadcast(EventsNames.OPEN_GRID_ATTACHMENTS_EDIT_POPUP + this.ATTACHMENTS_BRIDGE_POPUP_ID)
	}

	// #endregion

	//#region Technical Permissions

	private initializeTechnicalPermissions(task: OpTask): void {
		this.technicalPermissions = task.technicalPermissions

		this.initializeTechnicalPermissionsGrid(task)
		this.initializeTechnicalPermissionsGridEdit(task)
	}

	private initializeTechnicalPermissionsGrid(task: OpTask): void {
		this.technicalPermissionsGridOptions = null

		this.$timeout(() => {
			this.technicalPermissionsGridOptions = {
				addCustomFilters: true,
				columnsDictionary: this.technicalPermissionService.getTechnicalPermissionsGridColumns(),
				dataSource: task.technicalPermissions,
				name: this.TECHNICAL_PERMISSIONS_GRID_NAME,
				type: GridTypes.NO_SEARCH_BAR_SMALL,
				buttonsOptions: {
					enabled: false,
				},

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.GroupingLocationAssignedLocations), // todo TeskTechnicalPermissions
			}
		}, 200)
	}

	private initializeTechnicalPermissionsGridEdit(task: OpTask): void {
		this.referenceTypeService.getDictionaryReferenceObjectList(Enums.ReferenceType.IdTechnicalPermission).then((technicalPermissions: OpTechnicalPermission[]) => {
			const taskTechnicalPermissionsGridObject = _.map(task.technicalPermissions, (technicalPermission: OpTechnicalPermission) => {
				return {
					id: technicalPermission.idTechnicalPermission,
					name: technicalPermission.toString(),
					code: technicalPermission.code,
				}
			})

			this.technicalPermissionsGridEditOptions = {
				columns: this.taskTechnicalPermissionsService.getTechnicalPermissionsColumns(),
				data: technicalPermissions,
				id: this.$scope.modelId,
				items: taskTechnicalPermissionsGridObject,
				name: this.TASK_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME,
				popupId: this.TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP_ID,
				title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__TECHNICAL_PERMISSIONS_EDITING, Enums.SimaxModuleName.Task),

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskTechnicalPermissions),

				onSubmit: (addedItems: any[], removedItems: any[]) => {
					const deferred = this.$q.defer<boolean>()

					this.taskTechnicalPermissionsService
						.saveTechnicalPermissionsGridEditResult(task, addedItems, removedItems)
						.then((savedTask: OpTask) => {
							this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedTask)
							this.initializeTechnicalPermissions(savedTask)

							deferred.resolve(true)
						})
						.fail(() => {
							deferred.resolve(false)
						})

					return deferred.promise
				},
			}
		})
	}

	// #endregion

	//#region Issues

	private setTaskIssuesGridOptions(): void {
		this.taskIssuesGridOptions = null
		this.showTaskIssues = false

		const deferred: JQueryDeferred<OpIssue[]> = $.Deferred<OpIssue[]>()

		if (this.referenceObject != null && this.referenceObject.idTask > 0) {
			this.taskService.getTaskIssues(this.referenceObject.idTask).then((issues: OpIssue[]) => {
				deferred.resolve(issues)
			})
		} else {
			deferred.resolve([])
		}

		deferred.promise().then((issues: OpIssue[]) => {
			this.showTaskIssues = true
			this.taskIssues = issues

			this.taskIssuesGridOptions = {
				name: this.TASK_ISSUES_GRID_NAME,
				type: GridTypes.PAGINATED_SMALL,
				addCustomFilters: true,
				columnsDictionary: this.taskService.getTaskIssuesGridColumns(),
				dataSource: issues,

				buttonsOptions: {
					enabled: false,
				},

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TaskIssues),

				onRowDoubleClick: (args: any) => {
					this.onTaskIssuessDoubleClick(args, issues)
				},
			}
		})
	}

	private onTaskIssuessDoubleClick(args: any, issues: OpIssue[]): void {
		this.systemService.openDetails(<
			DetailsOptions //TODO replace it to issueService when it created
			>{
				moduleName: Enums.SimaxModuleName.Issue,
				pageItemsIds: issues.map((issue: OpIssue) => issue.idIssue),
				referenceObjectId: args.data[CommonHelper.idField],
			})
	}

	//#endregion

	//#region Send mail button

	private initializeSendmail(): void {
		this.mailButtonOptions = {
			icon: 'email',
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendEmail),
			onClick: () => {
				this.customActionsButtonPopover.hide()
				this.onSendMailButtonClick()
			},
		}

		this.initializeSendMailPopup()
	}

	private onSendMailButtonClick(): void {
		if (this.sendMailPopup != null) {
			this.sendMailPopup.show()
			this.isMailContentLoading = true

			this.userSession
				.getDataProvider()
				.Operator.getOperatorSettings(this.userSession.getIdLoggedOperator(), [Enums.SimaxOperatorSetting.TaskRealizationEmailTemplate], true)
				.then((result: any[]) => {
					const deferred: JQueryDeferred<string> = $.Deferred<string>()
					if (_.size(result) > 0) {
						this.userSession
							.getDataProvider()
							.System.getLocalizedFile(+result[0], this.userSession.getDataProvider().System.getCurrentLanguageId())
							.then((file: OpFile) => {
								deferred.resolve(file != null ? FileComponent.stringFromUTF8Array(file.fileBytes as number[]) : TypeHelper.emptyString)
							})
					} else {
						deferred.resolve(TypeHelper.emptyString)
					}

					$.when(deferred, this.getTaskAttachmentRequest).then((message: string, attachments: OpFile[]) => {
						this.initializeSendMailOptions(message, attachments)
						this.isMailContentLoading = false
					})
				})
		}
	}

	private initializeSendMailOptions(message: string, attachments: OpFile[]): void {
		//for PEC Gliwice only ?
		const emails: string[] = []
		const email: string = this.referenceObject.dataList.getValue(Enums.DataType.TASK_PROTOCOL_CUSTOMER_EMAIL_ADDRESS)

		if (!TypeHelper.isNullOrEmpty(email)) {
			emails.push(email)
		}

		this.sendMailOptions = {
			emails: emails,
			subject: `[${this.referenceObject.dataList.getValue(Enums.DataType.TASK_PROTOCOL_PEC_KOMEDIA_TASK_NUMBER)} / ${this.referenceObject.dataList.getValue(
				Enums.DataType.TASK_PROTOCOL_PEC_KOMEDIA_TASK_LOCATION_ADDRESS
			)}] Protokoły z prac wykonanych przez PEC Gliwice Sp. z o.o.`,
			message: message,
			attachments: attachments,
			onInitialized: (e: SendMailInitializedArgs) => {
				this.sendMail = e.component
			},
		}
	}

	private initializeSendMailPopup(): void {
		this.sendMailPopupOptions = {
			innerOptions: {
				title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendNotification),
				maxWidth: 600,
				maxHeight: 700,
			},
			bottomToolbarOptions: <IMRToolbarOptions>{
				items: [
					{
						location: 'after',
						widget: 'dxButton',

						options: {
							text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Send),
							hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Send),
							onClick: () => {
								if (this.sendMail != null) {
									const mail: OpEmail = this.sendMail.submitChanges()

									if (mail != null) {
										this.sendMailPopup.showLoading()
										this.userSession
											.getDataProvider()
											.System.sendEmailToClient(mail)
											.then((result: boolean) => {
												if (result == true) {
													this.sendMailPopup.hide()
													ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EmailSent), { displayTime: 5000 })
												} else {
													ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EmailSendError))
												}
											})
											.catch((error: any) => {
												ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
												LogHelper.warn(TaskService.LOG_PREFIX, `Unable to send email`, error)
											})
											.always(() => {
												this.sendMailPopup.hideLoading()
											})
									}
								}
							},
						},
					},
					{
						location: 'after',
						widget: 'dxButton',
						options: {
							text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
							hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
							onClick: () => {
								this.sendMailPopup.hide()
							},
						},
					},
				],
			},
			onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
				this.sendMailPopup = e.component
			},
			onHiding: (e: IMRPopupHidingArgs) => {
				this.sendMailOptions = null
			},
		}
	}

	//#endregion

	//#region

	private canFinishTask(): JQueryPromise<boolean> {
		return this.userSession
			.getDataProvider()
			.Task.getNextTaskStatuses(this.referenceObject.idTaskStatus)
			.then((statuses: OpTaskStatus[]) => {
				return _.find(statuses, (status: OpTaskStatus) => status.idTaskStatus == Enums.TaskStatus.Finished_succesfully) != null
			})
	}

	private canDeclineTask(): JQueryPromise<boolean> {
		return this.userSession
			.getDataProvider()
			.Task.getNextTaskStatuses(this.referenceObject.idTaskStatus)
			.then((statuses: OpTaskStatus[]) => {
				return _.find(statuses, (status: OpTaskStatus) => status.idTaskStatus == Enums.TaskStatus.NegativeVerification) != null
			})
	}

	private initializeCustomButtonsOptions(): JQueryPromise<void> {
		this.customActionsButtonOptions = null
		this.acceptTaskButtonOptions = null
		this.declineTaskButtonOptions = null

		return $.when(this.canFinishTask(), this.canDeclineTask()).then((canFinish: boolean, canDecline: boolean) => {
			const canSendMail: boolean =
				!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskSendMail, true) &&
				!TypeHelper.isNullOrEmpty(this.referenceObject.dataList.getValue(Enums.DataType.TASK_PROTOCOL_CUSTOMER_EMAIL_ADDRESS))

			const needAcceptButton: boolean =
				canFinish &&
				this.referenceObject.idTaskStatus != Enums.TaskStatus.Finished_succesfully &&
				!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskFinishedSuccessfullyButton, true)
			const needDeclineButton: boolean =
				canDecline &&
				this.referenceObject.idTaskStatus != Enums.TaskStatus.NegativeVerification &&
				!this.userSession.getLoggedOperator().hasPermission(Activity.TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskNegativeVerificationButton, true)

			if (canSendMail || needAcceptButton || needDeclineButton) {
				this.customActionsButtonOptions = {
					elementAttr: { id: this.customActionButtonIdentificator },
					icon: 'fields',
					onClick: () => {
						this.customActionsButtonPopover.toggle(true)
					},
				}

				this.customActionsButtonPopoverOptions = {
					onInitialized: (e: any) => {
						this.customActionsButtonPopover = e.component
					},
					target: `#${this.customActionButtonIdentificator}`,
					animation: {
						hide: {
							type: 'fadeOut',
						},
						show: {
							type: 'fadeIn',
						},
					},
				}
			}

			if (canSendMail) {
				this.initializeSendmail()
			}

			if (needAcceptButton) {
				this.acceptTaskButtonOptions = {
					icon: 'check',
					text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Accept),
					disabled: true,
					template: '<div dx-load-indicator="{height: 20, width: 20}"></div>',
					onClick: () => {
						if (this.customActionsButtonPopover != null) {
							this.customActionsButtonPopover.hide()
						}

						if (this.acceptTaskConfirmationPopup != null) {
							this.acceptTaskConfirmationPopup.show()
						}
					},
					onInitialized: (e: any) => {
						this.changeAcceptTaskStatusCustomButton(e)
					},
				}

				this.acceptTaskConfirmationPopupOptions = {
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
					content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SetTaskStatusFinishedSuccesfullyQuestion),
					onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
						this.acceptTaskConfirmationPopup = e.component
					},
					onConfirmed: () => {
						this.onChangeTaskStatus(Enums.TaskStatus.Finished_succesfully)
					},
				}
			}

			if (needDeclineButton) {
				this.declineTaskButtonOptions = {
					icon: 'close',
					text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Reject),
					disabled: true,
					template: '<div dx-load-indicator="{height: 20, width: 20}"></div>',
					onClick: () => {
						if (this.customActionsButtonPopover != null) {
							this.customActionsButtonPopover.hide()
						}

						if (this.declineTaskConfirmationPopup != null) {
							this.declineTaskConfirmationPopup.show()
						}
					},
					onInitialized: (e: any) => {
						this.changeDeclineTaskStatusCustomButton(e)
					},
				}

				this.declineTaskConfirmationPopupOptions = {
					title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
					content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SetTaskStatusNegativeVerificationQuestion),
					onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
						this.declineTaskConfirmationPopup = e.component
					},
					onConfirmed: () => {
						this.onChangeTaskStatus(Enums.TaskStatus.NegativeVerification)
					},
				}
			}
		})
	}

	private changeAcceptTaskStatusCustomButton(e: any): void {
		this.taskProtocolsPromise
			.promise()
			.then(() => {
				const acceptedProtocolsCount: number = _.size(
					_.filter(this.taskProtokols, (protokol: OpTaskProtocolVerification) => {
						return (
							protokol.statusTaskData != null &&
							protokol.statusTaskData.idDataType == Enums.DataType.TASK_PROTOCOL_VERIFICATION_STATUS &&
							protokol.statusTaskData.value == Enums.TaskProtocolVerificationStatus.Verified
						)
					})
				)

				e.component.option({ disabled: acceptedProtocolsCount != _.size(this.taskProtokols) })
			})
			.always(() => {
				e.component.option({ template: 'content' })
			})
	}

	private changeDeclineTaskStatusCustomButton(e: any): void {
		this.taskProtocolsPromise
			.promise()
			.then(() => {
				let acceptedProtocolsCount: number = 0
				let declinedProtocolsCount: number = 0

				_.forEach(this.taskProtokols, (protokol: OpTaskProtocolVerification) => {
					if (protokol.statusTaskData != null && protokol.statusTaskData.idDataType == Enums.DataType.TASK_PROTOCOL_VERIFICATION_STATUS) {
						if (protokol.statusTaskData.value == Enums.TaskProtocolVerificationStatus.Verified) {
							acceptedProtocolsCount++
						} else if (protokol.statusTaskData.value == Enums.TaskProtocolVerificationStatus.Rejected) {
							declinedProtocolsCount++
						}
					}
				})

				e.component.option({
					disabled: acceptedProtocolsCount + declinedProtocolsCount != _.size(this.taskProtokols) || declinedProtocolsCount == 0,
				})
			})
			.always(() => {
				e.component.option({ template: 'content' })
			})
	}

	private onChangeTaskStatus(taskStaus: Enums.TaskStatus): void {
		this.$scope.isLoading = true

		const taskToSave = new OpTask()
		taskToSave.copy(this.referenceObject, false, false, false, false)
		taskToSave.opState = Enums.OpChangeState.Modified
		taskToSave.idTaskStatus = taskStaus
		taskToSave.dataList.setValue(taskStaus, Enums.DataType.HELPER_ID_TASK_STATUS)

		this.taskService
			.saveTask(taskToSave)
			.then((task: OpTask) => {
				this.onRefresh(task)
			})
			.always(() => {
				this.$scope.isLoading = false
			})
	}

	//#endregion

	private saveChangeLocationEquipment(taskId: number, toAdd: OpLocationEquipment[]): JQueryPromise<void> {
		return this.userSessionService
			.getDataProvider()
			.Task.changeTaskUsedEquipment(taskId, toAdd)
			.then((response: OpTask) => {
				ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EquipmentAssigned), { displayTime: 5000 })
				this.onRefresh(response)
			})
			.fail((error: any) => {
				ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TaskEquipmentChangeError))
			})
	}

	private getProfileData(idDatatype: Enums.DataType): boolean {
		if (this.userSession.getLoggedOperator().profile != null && this.userSession.getLoggedOperator().profile.parameters != null) {
			return !!this.userSession.getLoggedOperator().profile.parameters.getValue(idDatatype)
		}

		return false
	}

	resetData() {
		this.onClear()
	} //DO USUNIECIA!!! - zastąpić onClear
	loadData(id: number, objects: any[]) {
		this.onOpen(null)
	} //DO USUNIECIA!!! - zastąpić onOpen
	updateData(result: any) {
		this.onRefresh(result)
	} //DO USUNIECIA!!! - zastąpić onRefresh
}

// #endregion
